import AccordionBody from 'Components/Atoms/Accordion/AccordionBody';
import AccordionHeader from 'Components/Atoms/Accordion/AccordionHeader';
import AccordionItem from 'Components/Atoms/Accordion/AccordionItem';
import BlockTitle from 'Components/Atoms/ExpandableItems/BlockTitle';
import React, { useState } from 'react';
import { getEntityDisplayValue } from 'Services/helpers';

function capitalize(s: any) {
    return s[0].toUpperCase() + s.slice(1);
}

const Accordion = ({children, title, isOpen, hasMargin}: any) => {
    const [isOpenState, setOpen] = useState(isOpen);

    return <AccordionItem isOpen={isOpenState}>
        <AccordionHeader onClick={() => setOpen(!isOpenState)}>
            <BlockTitle>{capitalize(title)}</BlockTitle>
        </AccordionHeader>
        <AccordionBody hasMargin={hasMargin}>
            { children }
        </AccordionBody>
    </AccordionItem>
}

export default Accordion;